import React from "react";
import { Eye } from "lucide-react";

const Show = ({ className = "size-6", onClick }) => (
  <Eye className={className} onClick={onClick} />
);

export default Show;
